import { ExclamationCircleOutlined } from '@ant-design/icons'
import { Button, Flex, Form, Input, Modal, Space } from 'antd'
import { useModalArticleItem } from 'src/pages/budget/hook'
import { closeModalArticleItem } from 'src/pages/budget/model'
import {
  submitAddArticleItem,
  submitUpdateArticleItem,
} from 'src/pages/budget/budgetCategories/model'
import { REQUIRED_FIELD } from 'src/pages/budget/const'
import { UiText } from 'src/pages/budget/components/uiText'

type FormValues = {
  name: string
  description: string
}

const ARTICLE_ITEM_NAME_MAX_LENGTH = 45

export const ModalArticleItem = () => {
  const modalArticleItemStore = useModalArticleItem()

  if (!modalArticleItemStore) return null
  const open = Boolean(modalArticleItemStore)

  const { articleItem, article, mode } = modalArticleItemStore

  const { Item } = Form
  const { TextArea } = Input

  const { articleId, number, name } = article
  const isNew = mode === 'new'

  const initialValues = articleItem
    ? { article: `${number}.${name}`, ...articleItem }
    : { article: `${number}.${name}` }

  const handleCancel = () => closeModalArticleItem()

  const handleSubmit = (values: FormValues) => {
    const payload = {
      name: values.name.trim(),
      description: values.description.trim(),
    }

    if (isNew) {
      submitAddArticleItem({ ...payload, articleId })
    } else if (articleItem) {
      submitUpdateArticleItem({
        articleItemId: articleItem.id,
        ...payload,
      })
    }

    closeModalArticleItem()
  }

  return (
    <Modal
      title={
        <div style={{ fontSize: 32 }}>
          {isNew ? 'Добавить новый пункт' : 'Редактировать пункт бюджета'}
        </div>
      }
      centered
      wrapClassName="ant_modal"
      width={600}
      maskClosable={false}
      open={open}
      onCancel={handleCancel}
      destroyOnHidden
      footer={null}
    >
      <Form
        layout="vertical"
        initialValues={initialValues}
        onFinish={handleSubmit}
      >
        <Item
          label={
            <UiText size={18} type="secondary">
              Статья
            </UiText>
          }
          name="article"
        >
          <Input disabled />
        </Item>
        <Item
          label={
            <UiText size={18} type="secondary">
              Название пункта *
            </UiText>
          }
          name="name"
          required={false}
          rules={[
            {
              required: true,
              message: REQUIRED_FIELD,
            },
            {
              max: ARTICLE_ITEM_NAME_MAX_LENGTH,
              message: `Максимальная длина названия — ${ARTICLE_ITEM_NAME_MAX_LENGTH} символов`,
            },
          ]}
          extra={
            <Space>
              <ExclamationCircleOutlined />
              Такое, чтобы другим пользователям было легко понять его
            </Space>
          }
        >
          <Input maxLength={ARTICLE_ITEM_NAME_MAX_LENGTH} />
        </Item>
        <Item
          label={
            <UiText size={18} type="secondary">
              Описание *
            </UiText>
          }
          name="description"
          required={false}
          rules={[
            {
              required: true,
              message: REQUIRED_FIELD,
            },
          ]}
        >
          <TextArea rows={6} />
        </Item>
        <Flex gap={8}>
          <Button style={{ flex: 1 }} size="large" onClick={handleCancel}>
            Отменить
          </Button>
          <Button
            type="primary"
            style={{ flex: 1 }}
            size="large"
            htmlType="submit"
          >
            {isNew ? 'Добавить пункт' : 'Сохранить'}
          </Button>
        </Flex>
      </Form>
    </Modal>
  )
}
